// Single source for how each SMS carrier is presented on the dashboard: the
// display label, the Liberian prefixes it covers, and its brand color. Brand
// colors are fixed carrier identities (not theme tokens), so they live here
// once instead of being inlined in each card. Keyed to match the backend
// Carrier enum values that the stats endpoint returns.

export interface CarrierDisplay {
  key: 'mtn' | 'orange' | 'unknown';
  label: string;
  /** Prefixes this bucket covers, or null where it is not a prefix rule. */
  prefixes: string | null;
  /** Brand hex, or a theme palette path for a bucket with no brand. */
  color: string;
}

export const DISPLAY_CARRIERS: readonly CarrierDisplay[] = [
  { key: 'mtn', label: 'MTN Lonestar', prefixes: '088, 055', color: '#ffcc00' },
  { key: 'orange', label: 'Orange Liberia', prefixes: '077', color: '#ff6600' },
];

/**
 * Recipients we hold no usable number for. They belong to no carrier, so they
 * get their own bucket rather than being dropped: the recipient breakdown is
 * meant to account for everyone, and these are the people SMS cannot reach.
 *
 * A theme token rather than a hex, because there is no brand to match.
 */
export const UNKNOWN_CARRIER: CarrierDisplay = {
  key: 'unknown',
  label: 'Unknown',
  prefixes: null,
  color: 'text.disabled',
};

/** Every bucket in the recipient breakdown. Sums to the full recipient count. */
export const RECIPIENT_CARRIER_BUCKETS: readonly CarrierDisplay[] = [
  ...DISPLAY_CARRIERS,
  UNKNOWN_CARRIER,
];
